export default __webpack_public_path__ + "static/media/Thumb_Hairstyle_14.cf81fd88.png";